/**
 * useFirstScreenOfSession Hook
 * Returns true if Action Dash was the first screen visited in the authenticated session.
 * Stores state in sessionStorage so later route visits or refreshes within
 * the tab session report accurately. Fails closed (false) if sessionStorage throws or on error.
 */

import { useState } from 'react';

const STORAGE_KEY_SESSION_SCREEN = 'action_dash_first_screen_seen';

export function recordFirstRoute(pathname: string): void {
  try {
    if (typeof window === 'undefined') return;
    const initialPath = window.sessionStorage.getItem(STORAGE_KEY_SESSION_SCREEN);
    if (!initialPath) {
      window.sessionStorage.setItem(STORAGE_KEY_SESSION_SCREEN, pathname);
    }
  } catch {
    // Fail closed
  }
}

export function isActionDashRoute(path: string): boolean {
  return path === '/' || path.startsWith('/dashboard') || path.startsWith('/action-dash');
}

export function useFirstScreenOfSession(): boolean {
  const [isFirstScreen] = useState<boolean>(() => {
    try {
      if (typeof window === 'undefined') return false;
      const initialPath = window.sessionStorage.getItem(STORAGE_KEY_SESSION_SCREEN);
      return initialPath ? isActionDashRoute(initialPath) : false;
    } catch {
      return false;
    }
  });

  return isFirstScreen;
}
